import {StoreObject, MakeStore} from "../../stem-core/src/state/Store";

export class CurrencySettings extends StoreObject {}

export const CurrencySettingsStore = MakeStore("CurrencySettings", CurrencySettings);
